import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import { Container, Spinner } from 'react-bootstrap'; // import Spinner

const API_URL = process.env.REACT_APP_API_URL;

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const [password, setPassword] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false); // track loading
  const token = searchParams.get('token');

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (password.length < 8) {
      return toast.error('Password must be at least 8 characters');
    }

    setIsSubmitting(true); // start spinner

    try {
      const res = await fetch(`${API_URL}/auth/reset`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, password }),
      });

      const data = await res.json();

      if (res.ok) {
        toast.success('Password reset successfully!');
        setTimeout(() => (window.location.href = '/login'), 2000);
      } else {
        toast.error(data.message);
      }
    } catch (err) {
      toast.error('Something went wrong. Please try again.');
    } finally {
      setIsSubmitting(false); // stop spinner
    }
  };

  return (
    <Container className="mt-5">
      <ToastContainer />
      <div className="home-page-wrapper">
        <div className="login-container">
          <h3>Reset your password</h3>
          <form onSubmit={handleSubmit}>
            <input
              type="password"
              placeholder="New password"
              className="input-control mb-3"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              disabled={isSubmitting}
            />
            <button
              className="btn btn-primary w-100 d-flex align-items-center justify-content-center"
              type="submit"
              disabled={isSubmitting}
            >
              {isSubmitting ? (
                <>
                  <Spinner animation="border" size="sm" className="me-2" />
                  Resetting...
                </>
              ) : (
                'Reset Password'
              )}
            </button>
          </form>
        </div>
      </div>
    </Container>
  );
}
